module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"media_summary_title":"포토&동영상","show_all":"전체보기"}}')
  delete Component.options._Ctor
}
